'use client';

import { useEffect, useRef } from 'react';
import { trackViewItemList, type AnalyticsItem } from '@/lib/analytics';

// Zero-render client component that fires GA4 view_item_list on mount.
// Drop into any server component that renders a product grid.
//
// The `key` prop is intentionally omitted — server pages re-render with
// fresh items when query string changes (e.g. /shop?accord=woody), and
// React's reconciliation will remount this with the new props, re-firing
// the event. The viewedRef guard inside prevents double-fire from React
// strict mode in dev.

export function TrackList({
  listId,
  listName,
  items,
}: {
  listId:   string;
  listName: string;
  items:    AnalyticsItem[];
}) {
  // Hash the inputs so a second render with the same items doesn't re-fire,
  // but a real change (filter applied, query updated) does.
  const key = listId + '|' + listName + '|' + items.map((i) => i.item_id).join(',');
  const lastKey = useRef<string | null>(null);

  useEffect(() => {
    if (lastKey.current === key) return;
    lastKey.current = key;
    trackViewItemList(listId, listName, items);
  }, [key, listId, listName, items]);

  return null;
}
